import * as React from "react";
import { useEffect } from "react";
import { Form, redirect, useActionData, useLoaderData } from "react-router-dom";
import { Button, Container, Input, Message } from "semantic-ui-react";
import { Header } from "../../components/header/header";
import "./login.css";
import { AppConfiguration } from "../../core/config/app-configuration";
import { MapViewerConfiguration } from "../../config/map-viewer-configuration";
import { UiState } from "../../core/ui-state";
import { ObjektwesenFooter } from "../../components/footer/objektwesen-footer";
import { RootStore } from "../../stores/root-store";
import { TransportError } from "../../stores/data-transporter";

export async function loader(
    rootStore: RootStore,
    uiStore: UiState,
    appConfig: AppConfiguration,
    mapViewerConfig: MapViewerConfiguration) {
    return { rootStore, uiStore, appConfig, mapViewerConfig };
}

export async function action({ request, rootStore }: { request: Request; rootStore: RootStore; }) {
    const formData = await request.formData();
    const email = formData.get("email") as (string | undefined);
    const password = formData.get("password") as (string | undefined);

    if (
        email !== undefined &&
        email.length >= 1 &&
        password !== undefined &&
        password.length >= 1
    ) {
        try {
            await rootStore.authenticationStore.login({
                email,
                password,
            })

            if (rootStore.authenticationStore.authorized()) {
                return redirect("/projekte");
            } else if (rootStore.authenticationStore.loggedIn()) {
                await rootStore.authenticationStore.logout();
                return "Fehlende Berechtigung!";
            }
        } catch (e: any) {
            if (e instanceof TransportError) {
                if ((e as TransportError).statusCode === 403) {
                    return "Ungültige E-Mail oder ungültiges Passwort!";
                }

                return "Unerwarteter Fehler!";
            }

            return "Unerwarteter Fehler!";
        }
    }

    return "Bitte E-Mail und Passwort angeben.";
}

export default function Login(): JSX.Element {

    const errorMsg = useActionData() as string;
    const { rootStore, uiStore, appConfig, mapViewerConfig } = useLoaderData() as any;

    useEffect(() => {
        if (errorMsg !== undefined && errorMsg !== "") {
            (document.getElementById("password") as HTMLInputElement).value = "";
        }
    });

    return (

        <div className="page">
            <Header uiStore={uiStore}
                    appConfig={appConfig}
                    capabilities={["search"]}
                    searchConfig={appConfig.search}
                    mapViewerConfig={mapViewerConfig}
                    authenticationStore={rootStore.authenticationStore}
            />
            <div id="layout" className="wrapper container layout">
                <main className="layout__main">

                    <div className="content one-col">
                        <div className="content__main">
                            <Container>
                                <h1>Willkommen beim Informationssystem Fruchtfolgeflächen</h1>
                                <p>
                                    Fruchtfolgeflächen müssen qualitativ und quantitativ, das heisst in der
                                    Bodenqualität und in der Flächensumme geschützt werden. Im Informationssystem wird
                                    die Beanspruchung, die Neuschaffung und die Kompensation von Fruchtfolgeflächen
                                    räumlich und fachlich erfasst, verwaltet, kontrolliert und dient dem
                                    haushälterischen Umgang von Fruchtfolgeflächen bei Bauvorhaben, in der
                                    raumplanerischen Nutzungsplanung sowie im Bodenschutz. Der Zugang erfolgt über das
                                    Kantons-Login für registrierte Benutzerinnen und Benutzer. Wenn Sie begründeten
                                    Bedarf für den Zugang haben, wenden Sie sich per E-Mail an <a
                                    href="mailto:geodaten@lu.ch">geodaten@lu.ch</a>.
                                </p>
                                <h2>Anmelden</h2>
                                <Form method="post" className="loginForm">
                                    <Input placeholder="E-Mail" name="email"/>
                                    <Input
                                        id="password"
                                        placeholder="Passwort"
                                        name="password"
                                        type="password"
                                    />
                                    {errorMsg && <Message error={true} compact={true}>{errorMsg}</Message>}
                                    <Button>Anmelden</Button>
                                </Form>
                            </Container>
                        </div>
                    </div>
                </main>
            </div>
            <ObjektwesenFooter/>
        </div>
    );
}
